export default "__VITE_ASSET__BrzCexMa__"